
<div
  class="user cursor-pointer"
  v-if="user && user.id"
  v-b-tooltip.hover
  :title="'Current user is ' + user.shortName"
>
  User: {{ user.shortName }} - All times displayed in: <span class="text-uppercase">{{user.timeZone}}</span>
</div>
